module.exports = __webpack_public_path__ + "img/team.7677c898.svg";